import React, { useState } from "react";
import { useInstantSearch } from "react-instantsearch";

const SearchByNum = () => {
    const { indexUiState, setIndexUiState } = useInstantSearch();
    const [value, setValue] = useState("");

    const handleChange = (e) => {
        const val = e.target.value;
        setValue(val);

        console.log("🔍 Input value:", val);

        const newState = {
            ...indexUiState,
            refinementList: {
                ...indexUiState.refinementList,
                num: val ? [val] : [],
            },
        };

        console.log("🧠 New UI State:", newState);

        setIndexUiState(newState);
    };

    console.log("📦 Current UI State:", indexUiState);

    return (
        <div>
            <input
                type="text"
                placeholder="Rechercher par numéro..."
                value={value}
                onChange={handleChange}
            />

            <p style={{ fontSize: "12px", marginTop: "5px" }}>
                Valeur actuelle : {value}
            </p>
        </div>
    );
};

export default SearchByNum;